"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    InteractionTagContext: function() {
        return InteractionTagContext;
    },
    InteractionTagContextProvider: function() {
        return InteractionTagContextProvider;
    },
    useInteractionTagContext_unstable: function() {
        return useInteractionTagContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const InteractionTagContext = /*#__PURE__*/ _react.createContext(undefined);
const interactionTagContextDefaultValue = {
    appearance: 'filled',
    disabled: false,
    handleTagDismiss: ()=>({}),
    interactionTagPrimaryId: '',
    shape: 'rounded',
    size: 'medium',
    value: ''
};
const InteractionTagContextProvider = InteractionTagContext.Provider;
const useInteractionTagContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(InteractionTagContext)) !== null && _React_useContext !== void 0 ? _React_useContext : interactionTagContextDefaultValue;
};
